<script>
let exports = {};

exports.alert = (techNote) => {
    if(techNote == 1){
        return Swal.fire(
          "เกิดข้อผิดพลาด",
          "การแสดงผลข้อมูลผิดพลาด",
          "error"
        );
    }else if(techNote == 2){
        return Swal.fire(
            "เกิดข้อผิดพลาด",
            "การกำหนดข้อมูลให้ตารางไม่ถูกต้อง",
            "error"
        );
    }else if(techNote == 3){
        return Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่สามารถเริ่มต้นข้อมูลได้",
            "error"
        );
    }else if(techNote == 4){
        return Swal.fire(
            "เกิดข้อผิดพลาด",
            "ข้อมูลบางคอลัมน์ผิดพลาดและไม่แสดงให้เห็น",
            "error"
        );
    }else if(techNote == 5){
        return Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบจำนวนข้อมูลรวม",
            "error"
        );
    }else if(techNote == 6){
        return Swal.fire(
            "เกิดข้อผิดพลาด",
            "ข้อมูลบางคอลัมน์ไม่ถูกต้อง",
            "error"
        );
    }else if(techNote == 7){
        return Swal.fire(
          "เกิดข้อผิดพลาด",
          "การเชื่อมต่อเซิร์ฟเวอร์ผิดพลาด",
          "error"
        );
    }
};

export default exports;
</script>


// WEBPACK FOOTER //
// App/Shared/DatatableWarning.vue